import { BaseDto } from './base-dto';

export class ActividadFisica extends BaseDto {
    public nombre !: string;
    public descripcion !: string;
 } 
